export default {
  cargoType: {
    GENERAL: '普货',
    DGR: '危险品',
    DANGEROUS: '危险品',
    PERISHABLE: '鲜活易腐',
    COLD_CHAIN: '冷链',
    OVERSIZE: '超大件',
    OVERSIZED: '超限货物',
    BATTERY: '带电货物',
    PHARMA: '医药',
    ECOMMERCE: '电商',
    LIVE_ANIMAL: '活体动物',
    VALUABLE: '贵重物品',
    SMART: '贵重品',
    WET: '湿货',
  },
  uldType: {
    PMC: 'PMC 标准集装板',
    PAG: 'PAG 高板',
    AKE: 'AKE 集装箱',
    PGE: 'PGE 半板',
    BULK: 'BULK 散舱',
    RKN: 'RKN 冷藏箱',
    PIV: 'PIV 危险品专用箱',
  },
  contractType: {
    LONG_TERM: '长期协议',
    TEMP: '临时订单',
  },
  customerLevel: {
    VIP: 'VIP',
    NORMAL: '普通',
    STRATEGIC: '战略合作',
  },
  paymentTerms: {
    PREPAID: '预付',
    COLLECT: '到付',
    MONTHLY: '月结',
  },
  productType: {
    OWN: '自有产品',
    OUTSOURCE: '外订',
    AIRLINE_SOURCE: '航司订舱',
    AIRLINE_BOOKING: '航司订舱',
  },
  customerSource: {
    SALES: '销售客户',
    ROUTE: '航线客户',
    COMPANY: '公司客户',
    INTERNAL: '集团内部客户',
  },
  transportMode: {
    DIRECT: '直飞',
    TRANSIT: '中转',
    TRANSFER: '中转',
    AIR_TO_LAND: '空运转陆运',
    MULTIMODAL: '联运',
  },
  legalEntityRelation: {
    SAME: '同法人',
    DIFF: '不同法人',
  },
  region: {
    ASIA_PACIFIC: '亚太',
    APAC: '亚太',
    AMERICAS: '美洲',
    EUROPE: '欧洲',
    MIDDLE_EAST: '中东',
    INDIA: '印度',
    AFRICA: '非洲',
  },
  profitRole: {
    ROUTE: '航线',
    SALES: '销售',
    GROUP_INTERNAL: '集团内',
    FIRST_LEVEL: '一级包',
    INTERNAL: '集团内',
    FIRST: '一级包',
  },
  temperature: {
    NORMAL: '常温',
    COLD_2_8: '2-8°C',
    FROZEN_20: '-20°C',
  },
  stackDirection: {
    UP: '向上',
    ANY: '任意',
  },
  tradeType: {
    GENERAL_TRADE: '一般贸易',
    EXPRESS: '快件',
    OTHER: '其他',
  },
  freightMode: {
    AIR_DIRECT: '空运直飞',
    AIR_TO_LAND: '空运转陆运',
    MULTIMODAL: '联运',
  },
  costType: {
    ESTIMATED: '预估',
    ACTUAL: '实际',
  },
  feeType: {
    HANDLING: '操作费',
    STORAGE: '仓储费',
    CUSTOMS: '报关费',
    TRANSPORT: '陆运费',
    SECURITY: '安检费',
    TERMINAL: '码头费',
    DOCUMENT: '单证费',
    OTHER: '其他',
  },
  dissolveReason: {
    FLIGHT_CANCELLED: '航班取消',
    INSUFFICIENT_SPACE: '舱位不足',
    CUSTOMER_REQUEST: '客户要求',
    OTHER: '其他',
  },
  bizOrderViewStatus: {
    UNVIEWED: '航线未查看',
    VIEWED: '航线已查看',
  },
  taxFlag: {
    TAXABLE: '应税',
    DUTY_FREE: '免税',
  },
  serviceItem: {
    BOOKING: '订舱服务',
    GROUND: '地面服务',
    MANIFEST: '舱单服务',
  },
  paymentMethod: {
    PREPAID: '预付',
    COLLECT: '到付',
  },
  warehouseStatus: {
    PENDING: '待补录入仓数据',
    ENTERED: '已确认实际数据',
  },
  dateFilter: {
    ALL: '全部',
    TODAY: '今天',
    DAYS3: '未来3天',
    WEEK: '未来一周',
  },
  weightFilter: {
    ALL: '全部',
    LT50: '<50KG',
    RANGE_50_100: '50-100KG',
    RANGE_100_300: '100-300KG',
    GT300: '>300KG',
  },
  cargoFilter: {
    GENERAL: '普货',
    NON_GENERAL: '非普货',
    ALL: '全部',
    DANGER: '危险品',
    TEMP: '温控',
    OVERSIZE: '超大件',
  },
  groupBy: {
    ROUTE: '按航线分组',
    ETD: '按ETD分组',
    DESTINATION: '按目的港分组',
    CUSTOMER: '按客户分组',
  },
  bubbleShare: {
    NONE: '否（按原始单价计费）',
    RATIO_2_8: '2/8分泡（让利80%泡重）',
    RATIO_3_7: '3/7分泡（让利70%泡重）',
    RATIO_5_5: '5/5分泡（对半分）',
    CUSTOM: '自定义',
  },
  bubbleRatio: {
    ACTUAL: '实际泡比',
    RATIO_167: '1:167（标准）',
    RATIO_130: '1:130',
    RATIO_120: '1:120',
    RATIO_100: '1:100',
    CUSTOM: '自定义',
  },
  bubbleDisplayMode: {
    RATE: '按单价体现',
    WEIGHT: '按计费重体现',
  },
  loginResult: {
    SUCCESS: '成功',
    FAIL: '失败',
  },
  customerStatus: {
    ACTIVE: '有效',
    INACTIVE: '无效',
  },
  userStatus: {
    ACTIVE: '启用',
    INACTIVE: '禁用',
  },
  agreementStatus: {
    ACTIVE: '生效',
    INACTIVE: '失效',
  },
  agreementPeriodStatus: {
    ONGOING: '进行中',
    ENDED: '已结束',
  },
  agreementType: {
    BSA: 'BSA 包板',
    VOLUME: '包量',
  },
  cycleType: {
    SINGLE: '单周期',
    WEEKLY: '循环周期（按周）',
    BIWEEKLY: '循环周期（2周）',
    SEMIMONTHLY: '循环周期（半月）',
    MONTHLY_WEEK: '循环周期（月度周）',
    MONTHLY: '循环周期（按月）',
  },
  occupationStatus: {
    OCCUPIED: '已占用',
    AVAILABLE: '可调',
  },
  weekDay: {
    MON: '周一',
    TUE: '周二',
    WED: '周三',
    THU: '周四',
    FRI: '周五',
    SAT: '周六',
    SUN: '周日',
  },
  nullOption: {
    NO_AGREEMENT: '— 不关联协议 —',
  },
  currency: {
    CNY: 'CNY 人民币',
    USD: 'USD 美元',
    HKD: 'HKD 港币',
  },
  notifyType: {
    TASK: '待办',
    WARNING: '预警',
    MILESTONE: '里程碑',
    INFO: '信息',
    URGENT: '紧急',
  },
  quickFilter: {
    thisMonthCompleted: '本月完结',
    lastMonthCompleted: '上月完结',
    thisQuarter: '本季度',
    lossRoute: '亏损航线',
  },
  unit: {
    piece: '件',
    ticket: '票',
    minute: '分钟',
    ton: '吨',
  },
  permissionType: {
    MENU: '菜单',
    BUTTON: '按钮',
    API: '接口',
  },
  dataScope: {
    ALL: '全部数据',
    SELF: '仅本人',
    DEPT: '本部门',
    DEPT_AND_CHILD: '本部门及以下',
  },
  dataScopeDesc: {
    ALL: '可查看所有数据',
    SELF: '只能查看自己创建的数据',
    DEPT: '可查看本部门所有数据',
    DEPT_AND_CHILD: '可查看本部门及子部门数据',
  },
  daySuffix: '日',
  // entry/dialogs 类型
  urgency: {
    URGENT: '紧急',
    NORMAL: '普通',
  },
  cargoDensity: {
    HEAVY: '重货',
    LIGHT: '泡货',
    NORMAL: '平货',
  },
  diffHandling: {
    AMEND: '调单（Amendment）',
    ABSORB: '内部消化（Absorb）',
    DISPUTE: '异议（Dispute）',
  },
  // entry/components/CenterPanel/MasterOrderItem/HawbCard 类型
  diffHandlingShort: {
    AMEND: '调单',
    ABSORB: '内部消化',
    DISPUTE: '异议复称',
  },
  dataSource: {
    ESTIMATED: '预估数据',
    CONFIRMED: '确认数据',
    ADJUSTED: '调单数据',
  },
  // 计费重计算规则（系统配置 chargeable_weight_rounding_rule）
  chargeWeightRule: {
    ROUND: '四舍五入（保留2位小数）',
    HALF_KG_UP: '半公斤向上进位（IATA标准）',
  },
  // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection 类型
  warehouseDataStatus: {
    PENDING: '未要求',
    REQUIRED: '待回填',
    ENTERED: '已回填',
    ADJUSTED: '已调单',
  },
  warehouseDataSource: {
    OPS: '航线代填',
    CS: '客服回填',
  },
}
